import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { userState } from "../../interface/MainInterface";
import Header from "../../mainContainer/Header";

interface propsType {
  userState: userState;
}

const MainPage = (props: propsType) => {
  return (
    <>
      <Header userState={props.userState} backGround={"transparent"} />
      <Box>
        <Box sx={{ p: 0 }}>
          <Stack spacing={0} direction="column">
            {/* Title */}
            <Box component={"div"} className="main-video">
              <video loop muted autoPlay playsInline>
                <source src="https://thd-upload.livehyundai.com/bluegury@hyundai-ite.com/c9059fed-ae74-4e13-93bd-54e589af9499/source-video/31f2ff0f-f20e-4ee4-bf9d-7f15a1167111.mp4" />
              </video>
              <div className="main-copy">
                <dl>
                  <dt className="roboto fw-300 wow fadeInUp animated color-white fs-normal ta-center" data-wow-delay="0.2s">
                    Digital Innovation Leader
                  </dt>
                  <dd className="roboto fw-700 wow fadeInUp animated color-white fs-big ta-center ml-0" data-wow-delay="0.4s">
                    HYUNDAI <span>IT&E</span> Vector Store
                  </dd>
                </dl>
              </div>
            </Box>
            {/* Title */}
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default MainPage;
